import Api from "@/api/Api";
import errorHandler from "@/utils/plugins/ErrorHandler";

const RESOURCE_MEETING_ROOM = "/api/meeting_room_reservations";

export default {
  async getMeetingRooms(params) {
    return await Api()
      .get(RESOURCE_MEETING_ROOM, { params: params })
      .catch((err) => errorHandler(err, null));
  },
  async createMeetingRoom(params) {
    return Api()
      .post(RESOURCE_MEETING_ROOM, params)
      .catch((err) => errorHandler(err, null));
  },
  async updateMeetingRoom(id, params) {
    return Api()
      .put(`${RESOURCE_MEETING_ROOM}/${id}`, params)
      .catch((err) => errorHandler(err, null));
  },
  async getMeetingRoom(id, params) {
    return Api()
      .get(`${RESOURCE_MEETING_ROOM}/${id}`, { params: params })
      .catch((err) => errorHandler(err, null));
  },
  async deleteMeetingRoom(id) {
    return Api()
      .delete(`${RESOURCE_MEETING_ROOM}/${id}`)
      .catch((err) => errorHandler(err, null));
  },
};
